import React, { useEffect, useRef, useState } from 'react';
import { CheckoutButton } from './CheckoutButton';
import { LIGHTBOX_EVENT } from './Lightbox/Lightbox';
import { PRICE, STICKY_BUY_LABEL } from '../data/checkout';

/** Buy buttons that make the bar redundant while they are on screen. */
const HIDE_WHEN_VISIBLE = ['offer-cta', 'final-cta'];
const inView = (id: string) => {
  const el = document.getElementById(id);
  if (!el) return false;
  const rect = el.getBoundingClientRect();
  return rect.top < window.innerHeight && rect.bottom > 0;
};

/** True once the hero has scrolled out of view. */
const pastHero = () => {
  const hero = document.getElementById('inicio');
  return hero ? hero.getBoundingClientRect().bottom < 0 : false;
};

/**
 * Mobile-only purchase bar. Appears after the hero and hides while another buy
 * button or the page viewer is on screen. The footer reserves space for it.
 */
export function StickyBuyBar() {
  const [visible, setVisible] = useState(false);
  const lightboxOpen = useRef(false);
  useEffect(() => {
    let frame = 0;
    const update = () => {
      frame = 0;
      setVisible(pastHero() && !lightboxOpen.current && !HIDE_WHEN_VISIBLE.some(inView));
    };
    const schedule = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };
    const onLightbox = (event: Event) => {
      lightboxOpen.current = Boolean((event as CustomEvent<boolean>).detail);
      schedule();
    };
    update();
    window.addEventListener('scroll', schedule, {
      passive: true
    });
    window.addEventListener('resize', schedule);
    window.addEventListener(LIGHTBOX_EVENT, onLightbox);
    return () => {
      if (frame) window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      window.removeEventListener(LIGHTBOX_EVENT, onLightbox);
    };
  }, []);
  return <div aria-hidden={!visible} className={`fixed inset-x-3 z-40 transition-[transform,opacity] duration-[250ms] md:hidden ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-[calc(100%+24px)] opacity-0'}`} style={{
    bottom: 'calc(12px + env(safe-area-inset-bottom))',
    transitionTimingFunction: 'cubic-bezier(0.23, 1, 0.32, 1)'
  }} data-id="element-320" data-mp="17rqh9idjyg04">
      <div className="flex items-center justify-between gap-3 rounded-[18px] bg-paper py-2 pl-4 pr-2 shadow-[0_18px_40px_-14px_rgba(52,52,49,0.45)] ring-1 ring-ivory-line" data-id="element-321" data-mp="2k17s50d8i0u8">
        <p className="min-w-0 leading-tight" data-id="element-322" data-mp="2xyea4sq4vvie">
          <span className="block text-[0.85rem] font-bold text-coral-ink" data-id="element-323" data-mp="2t2fove03qtm7">310 moldes</span>
          <span className="sr-only" data-id="element-324" data-mp="37qts3q1fkk3a"> · </span>
          <span className="mt-0.5 block text-[1.15rem] font-extrabold text-graphite" data-id="element-325" data-mp="37pr0ffwaadmb">{PRICE.label}</span>
        </p>
        <CheckoutButton label={STICKY_BUY_LABEL} size="sm" className="shrink-0" tabIndex={visible ? 0 : -1} data-id="element-326" data-mp="32ttn7igbhndr" />
      </div>
    </div>;
}